const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <span>&copy; {new Date().getFullYear()} Favorite Movies App</span>
        <span>Created by Nick LoVallo</span>
        <span>
          <a
            className="footer-link"
            href="https://nicklovallo.github.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://nicklovallo.github.io/
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
